__turbopack_context__.v({
  "button": "Favorite-module-sass-module__dqUAUG__button",
  "test": "Favorite-module-sass-module__dqUAUG__test",
});
